module.exports = __webpack_public_path__ + "static/media/sun-is-wrong.6dbf5e4d.mp3";